/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { SdsDivProps } from '../Component.props';
import { SPINNER_TYPE_REGULAR, SpinnerType } from './Spinner.types';

/**
 * The props for `<Spinner />`.
 */
export interface SpinnerProps extends SdsDivProps {
  /**
   * Hidden text to accompany the spinner.
   */
  hiddenText?: string;

  /**
   * Spinner type.
   */
  type?: SpinnerType;
}

/**
 * The default prop values for `<Spinner />`.
 */
export const spinnerDefaults = {
  hiddenText: `Loading...`,
  type: SPINNER_TYPE_REGULAR,
};
